import React from "react";

function MenuItemBubble({messageText, onClick}) {
  return (
    <div>
      <div className="menuItemBubble" onClick={onClick}>
         {messageText}
      </div>
    </div>
  );
}

export default MenuItemBubble;
